import React, { useEffect } from 'react';
import styles from '@cp/pages/AmeyoUtility/components/UploadNumbers/index.module.scss';
import { CheckIcon, CloseIcon, RefreshIcon } from '@icons';
import Button from '@primitives/Button';
import uploadComponent from '@cp/components/UploadComponent/UploadComponent';
import ErrorIconOutline from '@cp/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { noop } from '@utils/common';

type UploadErrorComponent = {
  message: string | boolean;
  onCancel: () => void;
  containerClassName?: string;
  fileName: string;
  showRetryIcon?: boolean;
  showValidationText?: boolean;
  messageClassName?: string;
  onRetry?: () => void;
};

function UploadErrorComponent({
  message,
  onCancel,
  containerClassName,
  fileName,
  showRetryIcon,
  showValidationText = true,
  messageClassName = '',
  onRetry = noop
}: UploadErrorComponent) {
  return (
    <>
      <div
        className={cx(
          'flex justify-between items-center text-gray-600 p-1.5 mt-3.5 rounded-lg border border-solid border-[--red-base] bg-[var(--pale-white)] h-[40px] ml-3 gap-2',
          containerClassName
        )}
      >
        <div className="flex justify-between gap-2">
          <ErrorIconOutline size={20} fillColor1="var(--red-base)" />
          <div className="max-w-[220px] text-ellipsis whitespace-nowrap   overflow-hidden">
            {fileName}
          </div>
        </div>
        <div className="flex gap-1 items-center">
          {showRetryIcon ? (
            <Button
              variant="text"
              onClick={e => {
                e.preventDefault();
                onRetry();
              }}
            >
              <div className="flex gap-2">
                <RefreshIcon width={20} height={20} />
              </div>
            </Button>
          ) : null}
          <Button
            variant="text"
            onClick={e => {
              e.preventDefault();
              onCancel();
            }}
          >
            <div className="flex gap-2">
              <CloseIcon width={20} height={20} />
            </div>
          </Button>
        </div>
      </div>
      {showValidationText ? (
        <div className={cx('text-red-500 ml-[20px] mt-[10px]', messageClassName)}> {message}</div>
      ) : null}
    </>
  );
}

export default UploadErrorComponent;
